// The Vibe panel's style icons: one 12×12 pixel drawing a style, painted into its <canvas data-style-icon> (the page's
// CSP allows no data: images, and a canvas costs no request). Every style in styles/index.js has one, and so does Mix
// (tests/style-icons.test.mjs); '.' is clear, every other letter a PALETTE colour.
export const PALETTE = {
  k: '#1c1a33', K: '#2e2b4d', S: '#5d6184', s: '#8a8fb0', W: '#c9c3d9', w: '#f3eee4',
  p: '#ff7eb6', P: '#c2508a', r: '#ef476f', R: '#a82745', o: '#ff9f43', O: '#c96a1b', y: '#ffd166', n: '#b0703f', N: '#7a4a26',
  g: '#5dd39e', G: '#2f8f66', c: '#48e5c2', b: '#4cc9f0', B: '#2a7fb8', v: '#9b7bff', V: '#6346c9',
};

export const STYLE_ICONS = {
  mix: [       // shuffle: two arrows crossing
    '............',
    '..........b.',
    'ppp.....bbbb',
    'PPPp...bBBbB',
    '...Pp.bB..b.',
    '....PpB.....',
    '....bPp.....',
    '...bB.Pp..p.',
    'bbbB...Ppppp',
    'BBB.....PPpP',
    '..........p.',
    '............',
  ],
  jazzhop: [   // a record
    '....SSSS....',
    '..SSKKKKSS..',
    '.SKKKsKKKKS.',
    '.SKKsKKKKKS.',
    'SKKKKppKKKKS',
    'SKKKpwwpKKKS',
    'SKKKpwwpKKKS',
    'SKKKKppKKKKS',
    '.SKKKKKsKKS.',
    '.SKKKKsKKKS.',
    '..SSKKKKSS..',
    '....SSSS....',
  ],
  piano: [     // keys under the lid
    '............',
    '.NNNNNNNNNN.',
    'NNNNNNNNNNNN',
    'RRRRRRRRRRRR',
    'wwkkwkkwWwwW',
    'wwkkwkkwWwwW',
    'wwkkwkkwWwwW',
    'wwWwwWwwWwwW',
    'wwWwwWwwWwwW',
    'NNNNNNNNNNNN',
    '............',
    '............',
  ],
  ambient: [   // the moon over a cloud
    '........yy..',
    '.......yy...',
    '......yy....',
    '......yy....',
    '......yyy...',
    '..www..yyyy.',
    '.wwwwww.....',
    'wwwwwwwwww..',
    'wwwwwwwwwwww',
    '.WWWWWWWWWW.',
    '............',
    '............',
  ],
  guitar: [    // a sunburst guitar
    '..........Ss',
    '.........sS.',
    '........nN..',
    '.......nN...',
    '..oo..nN....',
    '.oooooN.....',
    'ooOkkoo.....',
    'oooOkkoo....',
    '.ooooooo....',
    'oooyooo.....',
    'ooooooO.....',
    '.oooOO......',
  ],
  sad: [       // a rain cloud
    '............',
    '....sss.....',
    '..sssssss...',
    '.sssssssssS.',
    'ssssssssssss',
    '.SSSSSSSSSS.',
    '............',
    '..b...b...b.',
    '.b...b...b..',
    '............',
    '...b...b....',
    '..b...b.....',
  ],
  neosoul: [   // a ribbon mic
    '....ssss....',
    '...sWsWss...',
    '...WsWsWs...',
    '...sWsWss...',
    '...WsWsWs...',
    '....ssss....',
    '.....yy.....',
    '..y..yy..y..',
    '...y.yy.y...',
    '....yyyy....',
    '.....yy.....',
    '...yyyyyy...',
  ],
  bossa: [     // a palm on the beach
    '....ggg.....',
    '..ggGGGgg...',
    '.gg.gnGg.gg.',
    'g..g.nN.g..g',
    '.....nN.....',
    '......nN....',
    '......nN....',
    '......nN....',
    '.....nnN....',
    '....nnNN....',
    'yyyyyyyyyyyy',
    'bbBbbbbBbbbb',
  ],
  synth: [     // a cassette
    '............',
    'vvvvvvvvvvvv',
    'vppppppppppv',
    'vpwwwwwwwwpv',
    'vpwkkwwkkwpv',
    'vpwkkwwkkwpv',
    'vpwwwwwwwwpv',
    'vppppppppppv',
    'vvVVVVVVVVvv',
    'vVVsVVVVsVVv',
    'vvvvvvvvvvvv',
    '............',
  ],
  house: [     // a mirror ball
    '.....S......',
    '.....S....y.',
    '....WbWb....',
    '...bWbWbW...',
    '..WbwbWbWb..',
    '..bwbWbWbW..',
    '..WbWbWbWb..',
    '..bWbWbWbB..',
    '...bWbWbB...',
    '.y..WbWb....',
    '............',
    '............',
  ],
  dnb: [       // a bolt
    '.......ccc..',
    '......ccc...',
    '.....ccc....',
    '....ccc.....',
    '...ccccccc..',
    '......ccB...',
    '.....ccB....',
    '....ccB.....',
    '...ccB......',
    '..cB........',
    '.c..........',
    '............',
  ],
  dub: [       // a speaker, sounding
    'SSSSSSSS....',
    'SKKKKKKS....',
    'SKKssKKS.g..',
    'SKKssKKS..g.',
    'SKKKKKKS..g.',
    'SKKsssKS.g..',
    'SKsKKKsS....',
    'SKsKwKsS.g..',
    'SKsKKKsS..g.',
    'SKKsssKS..g.',
    'SKKKKKKS.g..',
    'SSSSSSSS....',
  ],
  chiptune: [  // a handheld
    '..SSSSSSSS..',
    '..SKKKKKKS..',
    '..SKggggKS..',
    '..SKgGggKS..',
    '..SKggGgKS..',
    '..SKKKKKKS..',
    '..SWWWWWWS..',
    '..SWkWWrWS..',
    '..SkkkrWWS..',
    '..SWkWWWWS..',
    '..SWWWssWS..',
    '..SSSSSSSS..',
  ],
  medieval: [  // a tower with a pennant
    '.....rr.....',
    '.....rrr....',
    '.....S......',
    '..s.s.s.s...',
    '..ssssssss..',
    '..sssssSss..',
    '..sssKKsSs..',
    '..sssKKsSs..',
    '..sssssSss..',
    '..ssNNNNSs..',
    '..ssNNNNSs..',
    '..ssNNNNSs..',
  ],
  japanese: [  // a torii
    'rr........rr',
    'rrrrrrrrrrrr',
    '.RRRRRRRRRR.',
    '..r..rr..r..',
    '.rrrrrrrrrr.',
    '..r......r..',
    '..r......r..',
    '..r......r..',
    '..r......r..',
    '..r......r..',
    '..R......R..',
    '..k......k..',
  ],
  oud: [       // a lantern
    '.....y......',
    '....ooo.....',
    '...ooooo....',
    '....OOO.....',
    '...OyyyO....',
    '..OywyyyO...',
    '..OyyyyyO...',
    '..OyyywyO...',
    '...OyyyO....',
    '....OOO.....',
    '...ooooo....',
    '....ooo.....',
  ],
  sitar: [     // a lotus
    '............',
    '......p.....',
    '.....ppp....',
    '.....pPp....',
    '..p..pPp..p.',
    '..pp.pPp.pp.',
    '...ppPPPpp..',
    'p..pppppp..p',
    '.pppppppppp.',
    '..GGGGGGGG..',
    '.gggggggggg.',
    '............',
  ],
  spooky: [    // a jack-o'-lantern
    '......G.....',
    '.....GG.....',
    '..oOooooOo..',
    '.ooOooooOoo.',
    'ooyyooooyyoo',
    'ooyyooooyyoo',
    'oooooooooooo',
    'ooyooyyooyoo',
    'oooyyyyyyooo',
    '.ooOooooOoo.',
    '..oOooooOo..',
    '............',
  ],
  classical: [ // a violin
    '.....NN.....',
    '.....Nn.....',
    '.....kk.....',
    '...nnkknn...',
    '..nnnkknnn..',
    '...nnkknn...',
    '..nKnwwnKn..',
    '.nnKnyynKnn.',
    '.nnnnwwnnnn.',
    '.nnnnwwnnnn.',
    '..nnnkknnn..',
    '...nnnnnn...',
  ],
};

/** Paint one style's icon into a 12×12 canvas (an unknown style leaves it clear). */
export function paintStyleIcon(canvas, id) {
  const rows = Object.hasOwn(STYLE_ICONS, id) ? STYLE_ICONS[id] : null, g = canvas.getContext('2d');
  if (!g) return;
  g.clearRect(0, 0, canvas.width, canvas.height);   // a canvas painted before (the vote's options change) starts clear
  if (!rows) return;
  rows.forEach((row, y) => [...row].forEach((ch, x) => {
    if (!PALETTE[ch]) return;
    g.fillStyle = PALETTE[ch];
    g.fillRect(x, y, 1, 1);
  }));
}

/** Paint every <canvas data-style-icon="id"> under `root`. */
export const paintStyleIcons = root => root.querySelectorAll('canvas[data-style-icon]').forEach(c => paintStyleIcon(c, c.dataset.styleIcon));
